module.exports = __webpack_public_path__ + "img/newspaper-icon.a1c69c6f.svg";